import StripChatVideo from "./StripChatVideo";
import React, { useEffect, useState } from "react";
import { IModel } from "services/StripChatService";
import { useModelsQuery } from "./queries";
import { className } from "../../../utils";

interface IProps {
  index: number;
}

const StripChat = ({ index }: IProps) => {
  const [model, setModel] = useState<IModel| null>(null);

  const { isSuccess, data } = useModelsQuery({
    forceClient: "1",
    strict: "1",
    fields: "geobans",
    limit: "20",
    tag: "girls/american"
  });

  useEffect(() => {
    isSuccess && data?.models && setModel(data.models[index] ?? null);
  }, [isSuccess, data, index]);

  return (
    <div
      className={className({
        player: true,
        fullscreen: true,
      })}
      style={{
        height: `${window.innerHeight}px`,
      }}
    >
      <StripChatVideo
        previewUrl={model?.previewUrl}
        videoUrl={model?.stream.url}
        avatarUrl={model?.avatarUrl}
        username={model?.username}
      />
    </div>
  );
};

export default StripChat;
